import clsx from "clsx";
import React, { useState } from "react";

import IconArrowRight1Active from "~/components/Icons/icon-arrow-right1-active";
import { getDocumentFile } from "~/pages/CatalogApplications/catalogApi";
import { DocumentItem } from "~/pages/CatalogApplications/types";
import { downloadBlob } from "~/shared/lib/downloadBlob";

import GetIcon from "./GetIcon";

import s from "./DocumentsSections.less";

type DocumentsSectionProps = {
  title: string;
  sectionData: { label: string; value: string; type: string }[];
  documents: DocumentItem[];
  accord?: boolean;
  titleAddon?: React.ReactNode;
};

const DocumentsSections: React.FC<DocumentsSectionProps> = ({
  title,
  sectionData,
  documents,
  accord = false,
  titleAddon,
}) => {
  const [open, setOpen] = useState<boolean>(true);

  const getFilename = (response: Response, originFileName?: string): string => {
    if (originFileName) return originFileName;

    // Truncate stem to 255-byte FS limit (Cyrillic ≈ 2 bytes/char),
    // preserving extension — otherwise the browser drops `download` attr
    // and saves under a UUID blob name.
    const cd = response.headers.get("content-disposition") || "";
    const name = decodeURIComponent(
      cd.match(/filename\*?="?(?:UTF-8'')?([^";]+)"?/i)?.[1] ?? "",
    );
    const dot = name.lastIndexOf(".");
    const ext = dot > 0 ? name.slice(dot) : "";
    const stem = dot > 0 ? name.slice(0, dot) : name;
    const enc = new TextEncoder();
    const maxStem = Math.max(10, 250 - ext.length);
    let cut = stem.length;
    while (cut > 0 && enc.encode(stem.slice(0, cut)).length > maxStem) cut--;
    return stem.slice(0, cut) + ext;
  };

  const handleDownload = async (fileId: string, originFileName?: string) => {
    try {
      const response = await getDocumentFile(fileId);
      await downloadBlob(response, getFilename(response, originFileName));
    } catch (err) {
      console.error("Ошибка при скачивании файла:", err);
    }
  };

  return (
    <div className={clsx(s.wrapper_files_block, !open && s.wrapper_border)}>
      <div className={s.title}>
        <span className={s.titleText}>{title}</span>
        <div className={s.titleActions}>
          {titleAddon}
          {accord && (
            <span
              onClick={() => setOpen(!open)}
              className={clsx(s.icon_wrapp, open ? s.open : s.close)}
            >
              <IconArrowRight1Active />
            </span>
          )}
        </div>
      </div>
      {open &&
        sectionData?.map(({ label, type }, index) => (
          <div
            key={index}
            className={`${s.section} ${index === 0 ? s.firstSection : ""}`}
          >
            <div className={s.label}>{label}</div>
            <div className={s.value}>
              {/*<a href={value} download>*/}
              {/*  <IconPdf />*/}
              {/*</a>*/}
              {documents
                .filter((doc) => doc.type === type)
                .map((doc) => (
                  <div
                    key={doc.fileId}
                    onClick={() => handleDownload(doc.fileId, doc.filename)}
                    className={s.downloadButton}
                  >
                    <GetIcon filename={doc.filename} />
                  </div>
                ))}
            </div>
          </div>
        ))}
    </div>
  );
};

export default DocumentsSections;
